fx.ns("desktop.player", class Splashscreen extends fx.Component {
    
	constructor()
	{
		super();

		this.showEffect = "fade";
        this.hideEffect = "fade";

		this.destroyOnSwitch = true;
	}
	
	// --------------------------- RENDER --------------------------- //

	create()
	{
		super.create();
	}

	onReady()
	{
		super.onReady();
		this.addChild(new fx.components.Image(fx.assets.loader), {width:50, height:50, top:"center", left:"center"} );
	}
	
});